import React from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { actionCreators } from "../CreateTask/action";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import StarIcon from "@material-ui/icons/Star";
import style from "./style.css";
import Draggable from "../Draggable";
import Dropable from "../Dropable";
import { PRIORITY } from "../Draggable/constant";
import Chip from '@material-ui/core/Chip';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useLocation } from 'react-router-dom'


const Task = ({
  checked,
  label,
  title,
  tag,
  description,
  priority,
  id,
  onClickFocus,
  onClick,
  focus,
  parent,
  action,
  done,
  openEditTaskForm,
  unsaved,
  projects
}) => {

  const getProjectName = (projectId) => {
    let projectName;
    projects.forEach((proj) => {
      if (proj.id === projectId) {
        projectName = proj.title;
      }
    });
    return projectName;
  };
  const location = useLocation().pathname.split('/')[1];
  const projectName = getProjectName(parent);
  return (
    <>
      <Dropable
        name={PRIORITY}
        priority={priority ? priority : null}
        action={action}
        done={done}>
        <div
          style={{ borderBottom: "1px solid silver" }}
        ></div>

        <Draggable taskId={id} priority={priority ? priority : null}>
          <FormControlLabel
            control={
              <>
                <DragIndicatorIcon style={{ cursor: 'grab' }} />
                <Checkbox checked={checked} value="gilad" onClick={onClick} />
                <FormControlLabel
                  control={
                    <Checkbox
                      icon={<StarBorderIcon />}
                      checkedIcon={<StarIcon />}
                      checked={focus}
                      onClick={onClickFocus}
                      value="checkedH"
                    />
                  }
                />
                <Link
                  onClick={() =>
                    openEditTaskForm({
                      title,
                      tag,
                      description,
                      id,
                      parent,
                      action
                    })
                  }
                  to=""
                >
                  {label ? label : "<add name>"}
                  {" "} <Chip size="small" label={priority} />
                  {projectName !== undefined && location !== 'project' && <Chip size="small" label={projectName}  color="primary" />}
                  {unsaved && <CircularProgress size={15} />}
                </Link>
              </>
            }
            className="task-bordered"
          />
        </Draggable>
      </Dropable>
    </>
  );
}


const mapStateToProps = (state, props) => {

  function isProject(idTask) {
    const task = state.tasks[idTask];
    return task.project === true;
  }

  function isOpen(idTask) {
    const task = state.tasks[idTask];
    return task.done === false;
  }

  const projects = state.tasks && Object.keys(state.tasks)
    .filter(isProject)
    .filter(isOpen)
    .map(key => state.tasks[key]);

  return {
    projects: projects,
  };
};


export default connect(mapStateToProps, actionCreators)(Task);
